import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/home3.png'
import _imports_1 from '../assets/home3 (2).png'
import _imports_2 from '../assets/imageaboutus.png'
import _imports_3 from '../assets/schemeimg (3).png'


const _hoisted_1 = { class: "intermediate" }
const _hoisted_2 = { class: "schemeCard" }
const _hoisted_3 = { class: "schemeCard-margin" }
const _hoisted_4 = { class: "schemeCard" }
const _hoisted_5 = { class: "bgImg schemeCard-bgImg schemeCard-margin" }
const _hoisted_6 = { class: "aboutus" }
const _hoisted_7 = { class: "schemeCard" }
const _hoisted_8 = { class: "schemeCard-margin" }
const _hoisted_9 = {
  key: 0,
  src: _imports_1,
  class: "newsCard-img"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_2,
  class: "newsCard-img"
}
const _hoisted_11 = {
  key: 2,
  src: _imports_0,
  class: "newsCard-img"
}
const _hoisted_12 = {
  key: 3,
  src: _imports_3,
  class: "newsCard-img"
}
const _hoisted_13 = { class: "newsCard-title" }
const _hoisted_14 = { class: "newsCard-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_SchemeCard = _resolveComponent("SchemeCard")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_NewsCard = _resolveComponent("NewsCard")!
  const _component_BottomBar = _resolveComponent("BottomBar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_TopBar, { "new-id": 0 }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_carousel, {
        style: {"z-index":"0"},
        autoplay: true
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "bgImg carouselImg img1" }, [
            _createElementVNode("div", { class: "carouseCard carouseCard-left" }, [
              _createElementVNode("div", { class: "carouseCard-title" }, "集抄平台解决方案"),
              _createElementVNode("div", { class: "carouseCard-desc" }, " 物联网直读水表采用脉冲采样与直读采样技术相结合的独特采样方式，确保机械读数与电子读数一致，通过网络方式进行自动联网通讯，实现水表使用水量的远程自动抄收 ")
            ])
          ], -1),
          _createElementVNode("div", { class: "bgImg carouselImg img2" }, [
            _createElementVNode("div", { class: "left" }, [
              _createElementVNode("div", { class: "carouseCard carouseCard-right" }, [
                _createElementVNode("div", { class: "carouseCard-title" }, "智慧水务解决方案"),
                _createElementVNode("div", { class: "carouseCard-desc" }, " 实现水务业务系统的控制智能化、数据资源化、管理精确化、决策智慧化，保障水务设施安全运行，使水务业务运营更高效、管理更科学和服务更优质。 ")
              ])
            ])
          ], -1)
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "schemeCard-title" }, "解决方案", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "schemeCard-line" }, null, -1)),
          _createVNode(_component_a_flex, { class: "schemeCard-bottom" }, {
            default: _withCtx(() => [
              _createVNode(_component_SchemeCard, {
                num: 0,
                size: "big"
              }),
              _createVNode(_component_SchemeCard, {
                num: 1,
                size: "small",
                class: "schemeCard-left"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_flex, null, {
            default: _withCtx(() => [
              _createVNode(_component_SchemeCard, {
                num: 2,
                size: "small"
              }),
              _createVNode(_component_SchemeCard, {
                num: 3,
                size: "small",
                class: "schemeCard-left"
              }),
              _createVNode(_component_SchemeCard, {
                num: 4,
                size: "small",
                class: "schemeCard-left"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "schemeCard-title" }, "关于我们", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "schemeCard-line" }, null, -1)),
          _createVNode(_component_a_flex, { align: "flex-start" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "aboutus-title" }, "山东沃智达技术有限公司", -1)),
                _createVNode(_component_a_flex, null, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "aboutus-line1" }, null, -1),
                    _createElementVNode("div", { class: "aboutus-line2" }, null, -1)
                  ])),
                  _: 1
                }),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "aboutus-desc" }, " 山东沃智达技术有限公司专注于智慧水务领域的创新型科技企业，致力于为水务行业提供先进、高效、可持续的智能化解决方案。业务范围涵盖供水、排水、节水等水务领域的技术咨询、系统设计、软件开发、运维服务等。 ", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "aboutus-desc aboutus-top" }, " 沃智达始终秉承 “以创新立足市场，以智慧经营未来” 的经营理念，不断提升自主研发与生产工艺的核心技术能力，贴近客户需求，助力中国智造，持续为用户提供多功能一体化的智慧水务综合管理平台，致力于成为国际领先、以服务为本，覆盖上下游业务领域的综合服务商。 ", -1))
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("img", {
                class: "aboutus-img",
                src: _imports_0
              }, null, -1))
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "schemeCard-title" }, "新闻动态", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "schemeCard-line" }, null, -1)),
          _createVNode(_component_a_flex, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_ctx.newsCardNum == 0)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                  : (_ctx.newsCardNum == 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                    : (_ctx.newsCardNum == 2)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                      : (_openBlock(), _createElementBlock("img", _hoisted_12)),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.newsCardTiTle), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.doText), 1)
              ]),
              _createVNode(_component_a_carousel, {
                autoplay: true,
                class: "newsCard-left newsCard-card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsCards, (item, index) => {
                      return (_openBlock(), _createBlock(_component_NewsCard, {
                        size: "m",
                        key: item.id,
                        content: item,
                        onMousemove: ($event: any) => {
                    _ctx.newsCardNum = index;
                    _ctx.newsCardTiTle = item.title;
                    _ctx.newsCardDesc = item.body;
                  }
                      }, null, 8, ["content", "onMousemove"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsCards1, (item, index) => {
                      return (_openBlock(), _createBlock(_component_NewsCard, {
                        size: "m",
                        key: item.id,
                        content: item,
                        onMousemove: ($event: any) => {
                    _ctx.newsCardNum = index;
                    _ctx.newsCardTiTle = item.title;
                    _ctx.newsCardDesc = item.body;
                  }
                      }, null, 8, ["content", "onMousemove"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsCards2, (item, index) => {
                      return (_openBlock(), _createBlock(_component_NewsCard, {
                        size: "m",
                        key: item.id,
                        content: item,
                        onMousemove: ($event: any) => {
                    _ctx.newsCardNum = index;
                    _ctx.newsCardTiTle = item.title;
                    _ctx.newsCardDesc = item.body;
                  }
                      }, null, 8, ["content", "onMousemove"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_BottomBar)
  ]))
}